enum DeliveryOrderType {
    MONEY_DELIVERY = 'MONEY_DELIVERY',
    ARTICLE_DELIVERY = 'ARTICLE_DELIVERY',
    PACKAGE_DELIVERY = 'PACKAGE_DELIVERY',
}
export default DeliveryOrderType